<script lang="ts">
  import { _ } from 'svelte-i18n'
  import { isHaveItems } from '../../store'
  import {isShowSearchLoader} from "../../../../stores";
  import NoItemsBanner from '../../../../custom/NoItemsBanner.svelte'
</script>

{#if !$isShowSearchLoader && !$isHaveItems}
  <NoItemsBanner 
    title="{$_('favoritesEmptyBannerTitle')}"
    subtitle="{$_('favoritesEmptyBannerDescription')}"
    background="/static/no-items.jpeg" 
  />
{/if}